import { UserIcon } from '@phosphor-icons/react';

interface TestInMobileAppInstructionsProps {
  /** Noun used in the copy: 'story' on story-edit/editor, 'project' on project pages */
  noun?: 'story' | 'project';
}

/**
 * Shared 5-step "test in the Lureo mobile app" instructions.
 * Rendered inline by the standalone TestInMobileAppDialog and the
 * collapsible inside the share dialogs so the copy lives in one place.
 */
export function TestInMobileAppInstructions({ noun = 'story' }: TestInMobileAppInstructionsProps) {
  return (
    <div className="space-y-3">
      <p className="text-lureo-14 font-medium text-lureo-ink-subtle leading-5">
        Follow these steps to test this {noun} as an app experience:
      </p>
      <ul className="space-y-3">
        <Step n={1}>
          Download the <strong>Lureo mobile app</strong>.
        </Step>
        <Step n={2}>
          Log in with the <strong>same account</strong> you're using here.
        </Step>
        <Step n={3}>
          <span>In </span>
          <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-lureo-neutral rounded-lureo-radius text-lureo-12 align-middle leading-4">
            <UserIcon className="w-3.5 h-3.5" />
          </span>
          <span> navigate to "My Projects" and select this project.</span>
        </Step>
        <Step n={4}>
          Select this {noun}, tap <strong>"See More"</strong>, then <strong>"Start"</strong>.
        </Step>
        <Step n={5}>
          Once you're happy with the results, return to the <strong>{noun} page on your computer</strong> to publish.
        </Step>
      </ul>
    </div>
  );
}

function Step({ n, children }: { n: number; children: React.ReactNode }) {
  return (
    <li className="flex items-start gap-3">
      <span className="flex items-center justify-center w-6 h-6 rounded-full bg-lureo-neutral-strong text-lureo-ink font-bold text-lureo-14 shrink-0 leading-5">
        {n}
      </span>
      <span className="text-lureo-14 text-lureo-ink pt-0.5 leading-5">{children}</span>
    </li>
  );
}
